import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';
import { CARD_WIDTH, SLIDES_DESKTOP, SLIDES_MOBILE, SLIDES_PART, SLIDES_TABLET } from "./constants";
export var useGetSlidesPerView = function useGetSlidesPerView(dimension, carouselRef, maxSlides) {
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    slidesPerView = _useState2[0],
    setSlidesPerView = _useState2[1];
  useEffect(function () {
    if (dimension === 'mobile') {
      setSlidesPerView(SLIDES_MOBILE + SLIDES_PART);
    }
    if (dimension === 'tablet') {
      setSlidesPerView(SLIDES_TABLET + SLIDES_PART);
    }
    if (dimension === 'desktop' && maxSlides === 4) {
      setSlidesPerView(SLIDES_DESKTOP);
    }
    if (carouselRef !== null && carouselRef !== void 0 && carouselRef.current) {
      // оставлено в прежнем рабочем режиме для кейсов как на шопе, где макс слайдов 6 и 7. дизы должны договориться
      if (dimension === 'desktop' && maxSlides > 4) {
        var carouselWidth = carouselRef.current.clientWidth;
        var slide = Math.floor(carouselWidth / CARD_WIDTH.desktop);
        setSlidesPerView(maxSlides < slide ? maxSlides : slide);
      }
    }
  }, [carouselRef, maxSlides, dimension]);
  return slidesPerView;
};
export var useGetSlidesPerGroup = function useGetSlidesPerGroup(dimension) {
  if (dimension === 'mobile') {
    return SLIDES_MOBILE;
  }
  if (dimension === 'desktop') {
    return SLIDES_DESKTOP;
  }
  return SLIDES_TABLET;
};